import { useNavigate } from "react-router-dom";
import { ChevronRight, Users, Heart, Ribbon, Droplet, Sparkles } from "lucide-react";

const ELDER = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/369110568c1e38ef77cac9d3563a0c8d1bdeed84b8c97f464ef74592a5f8a3b9.jpeg";
const WOMEN = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/b5f3654b9a06380b6b2ecf732a7e5c8d909325194c7d11171737f9e5bcb28f4b.jpeg";
const CANCER = "https://static.prod-images.emergentagent.com/jobs/67e85589-df3b-4949-9f26-d13809d545ec/images/d3241c0f95846aabcc0c5ef1f3fdded2126a1cfc50419378de4acb64dcfd777c.jpeg";
const DIABETES = "https://images.pexels.com/photos/16984203/pexels-photo-16984203.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=800";

const CARDS = [
  { key: "elder", title: "Elderly Care", subtitle: "Healthy ageing with continuous support", image: ELDER, Icon: Users, color: "#16A34A", box: "#DCFCE7", bg: "#ECFBF2", border: "#CDEFDC", to: "/senior-care" },
  { key: "women", title: "Women Care", subtitle: "Care for every stage of a woman's life", image: WOMEN, Icon: Heart, color: "#DB2777", box: "#FCE7F0", bg: "#FDEBF3", border: "#F8CFE0", to: "/women-care" },
  { key: "cancer", title: "Cancer Support", subtitle: "Guidance, treatment support and emotional care", image: CANCER, Icon: Ribbon, color: "#7C3AED", box: "#F3E8FF", bg: "#F6EEFF", border: "#E4D3FA", to: "/cancer-care" },
  { key: "diabetes", title: "Diabetes Reversal", subtitle: "Better choices. Healthier tomorrow.", image: DIABETES, Icon: Droplet, color: "#0284C7", box: "#E0F2FE", bg: "#E8F5FE", border: "#C7E6FB", to: "/diabetes-reversal" },
];

export default function SpecialistCare() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold">Specialist Care Services</h1>
        <p className="text-muted-foreground mt-1">Expert support for every stage of life.</p>
      </div>

      {/* Cards */}
      <div className="space-y-3">
        {CARDS.map((c) => (
          <button
            key={c.key}
            onClick={() => navigate(c.to)}
            data-testid={`specialist-card-${c.key}`}
            className="relative w-full overflow-hidden rounded-3xl text-left transition-all hover:shadow-md"
            style={{ backgroundColor: c.bg, border: `1px solid ${c.border}`, minHeight: 116 }}
          >
            <img src={c.image} alt={c.title} className="absolute right-0 top-0 h-full w-[42%] object-cover" />
            <div className="absolute right-0 top-0 h-full w-[52%]" style={{ background: `linear-gradient(90deg, ${c.bg} 35%, transparent)` }} />
            <div className="relative z-10 w-[64%] p-5">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl" style={{ backgroundColor: c.box }}>
                <c.Icon className="h-5 w-5" style={{ color: c.color }} />
              </span>
              <p className="mt-3 text-lg font-extrabold" style={{ color: "#15296B" }}>{c.title}</p>
              <p className="text-sm text-muted-foreground mt-0.5">{c.subtitle}</p>
            </div>
            <ChevronRight className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-500 z-20" />
          </button>
        ))}
      </div>

      {/* Dr Sanjeevani CTA */}
      <button
        onClick={() => navigate("/assistant")}
        data-testid="specialist-dr-sanjeevani"
        className="w-full flex items-center gap-3 rounded-2xl border border-border bg-muted/40 p-4 text-left hover:bg-muted transition-colors"
      >
        <span className="h-10 w-10 rounded-full flex items-center justify-center" style={{ backgroundColor: "#F3E8FF" }}>
          <Sparkles className="h-5 w-5" style={{ color: "#7C3AED" }} />
        </span>
        <div className="flex-1">
          <p className="text-xs text-muted-foreground">Not sure which service is right for you?</p>
          <p className="font-bold" style={{ color: "#15296B" }}>Talk to Dr Sanjeevani</p>
        </div>
        <ChevronRight className="h-5 w-5" style={{ color: "#7C3AED" }} />
      </button>
    </div>
  );
}
